import React from "react";

const TelQrCode = ({ setQrData }) => {
    const handleInputChange = (e) => {
        const value = e.target.value;
        setQrData(`tel:${value}`);
    };

    return (
        <div className="form-group general-field">
            <label htmlFor="qr-data">Conteúdo</label>
            <input type="tel" id="qr-data" placeholder="+55 11 91234-5678" onChange={handleInputChange} />
        </div>
    );
};

export default TelQrCode;